module.exports = __webpack_public_path__ + "static/media/11_Maalouf.e2c70378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/11_Maalouf.png
// module id = 110
// module chunks = 0